// 用来检测屏幕的宽度，从而确定元素的显示和隐藏
export default {
    created () {
        window.addEventListener('resize', (e) => {
            this.innerWidth = e.target.innerWidth;
        });
    },
    computed: {
        isPc () {
            return this.innerWidth >= 1200;
        },
    },
    data () {
        return {
            innerWidth: window.innerWidth,
        }
    }
}